module.exports = __webpack_public_path__ + "img/collection-weddingRingsFinishes@2x.90d3e8b.webp";